export interface NonWorkingDayModel {
    _id?: string;
    name: string;
    metadata: {
      createdAt: Date;
      updatedAt: Date;
    };
    applyTo: {
        resourceType: string;
        resourceId: string[];
    }
    description?: string;
    date: {
        from: Date;
        to: Date;
    };
    branch: string;
  }
